/**
 * Build-time debug switch. The `__DEBUG__` global is replaced by Vite's
 * `define` option with a literal boolean — so every `if (DEBUG) { ... }` block
 * is tree-shaken away in production. Don't import anything heavy here that
 * would defeat the strip.
 *
 * Default ON. Flip OFF for production: `VITE_DEBUG=false npm run build`.
 */
export const DEBUG: boolean = __DEBUG__;
